import { useState, useEffect } from 'react'

const DEFAULT_DELAY = 200

const useDebounce = <T>(value: T, { delay = DEFAULT_DELAY, enabled = true } = {}) => {
	const [debouncedValue, setDebouncedValue] = useState(value)
	useEffect(() => {
		const handler = window.setTimeout(() => {
			if (enabled) setDebouncedValue(value)
		}, delay)
		return () => {
			window.clearTimeout(handler)
		}
	}, [value, delay, enabled])
	return debouncedValue
}

export default useDebounce
